export default __webpack_public_path__ + "static/media/img_07.45e8555c.webp";